export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.40a47176.png";